import { useTexts } from '../../useTexts'

import { form } from '../../formState'
import { createValidateBackupSubjectCustom } from '../../hooks/createValidateBackupSubjectCustom'

export function NotificationBackupSubject() {
  const texts = useTexts()
  const backupNotification = form.useFormField('backupNotification')
  const backupNotificationValue = backupNotification.field.value

  form.useAddFieldValidation<'backupSubjectCustom'>('backupSubjectCustom', (field, _formApi) => {
    const validationBackupSubjectCustom = createValidateBackupSubjectCustom(
      texts,
      field.value,
      backupNotificationValue ?? false,
    )
    return (
      validationBackupSubjectCustom.backupSubjectCustomRequired?.message ||
      validationBackupSubjectCustom.backupSubjectCustomMaxLengthError?.message
    )
  })

  return (
    <form.TextField
      label={texts.backupSubjectLabel(backupNotificationValue ?? false)}
      name="backupSubjectCustom"
      testId="backupSubjectCustom"
      validateOn="change"
    />
  )
}
